import { Component, OnInit, Input } from "@angular/core";
import { FormArray, FormBuilder, Validators } from "@angular/forms";
import { DashboardService } from "../../../../../services/dashboard.service";
import { SharedService } from "../../../../../services/shared.service";
import dictionary from "../../../../../utils/dictionary.json";
import * as _ from "lodash";

@Component({
  selector: "app-metadata-form",
  templateUrl: "./metadata-form.component.html",
  styleUrls: ["./metadata-form.component.css"],
})
export class MetadataFormComponent implements OnInit {
  formArray: FormArray;
  blocco: any;

  metadata: Array<any>;
  suggestion: Array<boolean> = [];
  list: Array<string> = [];
  suggestionList: Array<string> = [];

  getGroupValue = (index) => this.formArray.controls[index].value;
  getGroup = (index) => this.formArray.controls[index];

  constructor(
    private fb: FormBuilder,
    private _dashboardService: DashboardService,
    private _sharedService: SharedService
  ) {}

  ngOnInit() {
    // this.blocco = this._sharedService.getBlocco();
    this.list = dictionary.map((suggestion) => suggestion.name);
    this.blocco = {
      ...this._sharedService.getBlocco(),
      ...(!this._sharedService.getBlocco().blocchiIFRAMEUserDefined && {
        blocchiIFRAMEUserDefined: [],
      }),
      ...(!this._sharedService.getBlocco().blocchiLINKUserDefined && {
        blocchiLINKUserDefined: [],
      }),
    };
    this.formArray = new FormArray([]);
    if (this.blocco.codiceBloccoTipo === "IFRAME") {
      this.metadata = this.blocco.blocchiIFRAMEUserDefined;
    } else if (this.blocco.codiceBloccoTipo === "LINK") {
      this.metadata = this.blocco.blocchiLINKUserDefined;
    }
    if (this.metadata.length) {
      for (const item of this.metadata) {
        this.addNewFormGroup(item);
      }
      this.addNewFormGroup();
    } else {
      this.addNewFormGroup();
    }
  }

  addNewFormGroup(item?: { nome: string; valore: string }) {
    this.formArray.push(
      this.fb.group({
        nome: [item && item.nome ? item.nome : ""],
        valore: [item && item.valore ? item.valore : ""],
      })
    );
    this.suggestion.push(false);
  }

  deleteRow(index: number) {
    // delete
    const values = this.formArray.value[index];
    const prevValues = this.metadata[index];
    const { nome, valore } = values;
    const bloccoMetadataDelete = {
      idBlocco: this.blocco.id,
      nome: nome,
      valore: valore,
      id: prevValues.id,
    };
    this._dashboardService
      .deleteMetadata(bloccoMetadataDelete, this.blocco.codiceBloccoTipo)
      .subscribe((res) => {
        this.formArray.removeAt(index);
      });
  }

  addRow(index: number) {
    const values = this.formArray.value[index];
    const prevValues = this.metadata[index];
    const { nome, valore } = values;
    if (nome && valore) {
      const bloccoMetadata = {
        id: 0,
        idBlocco: this.blocco.id,
        nome: nome,
        valore: valore,
      };
      if (prevValues) {
        const bloccoMetadataEdit = {
          ...bloccoMetadata,
          id: prevValues.id,
        };
        if (!_.isEqual(prevValues, bloccoMetadataEdit)) {
          //update
          this._dashboardService
            .editMetadata(bloccoMetadataEdit, this.blocco.codiceBloccoTipo)
            .subscribe((res) => {});
        }
      } else {
        //add
        this._dashboardService
          .addMetadata(bloccoMetadata, this.blocco.codiceBloccoTipo)
          .subscribe((res) => {
            this.metadata.push(res);
            this.addNewFormGroup();
          });
      }
    }
  }

  checkSuggestions(event, i) {
    const input = event.target.value;
    const list = this.list.filter((item) =>
      item.startsWith(event.target.value)
    );
    const found = this.list.find((item) => item === input);
    if (input.startsWith("@") && list && list.length > 0 && !found) {
      this.suggestion[i] = true;
      this.suggestionList = list;
    } else {
      this.suggestion[i] = false;
    }
  }

  onSuggestionClick(suggestion, i) {
    let value = this.getGroup(i).get("valore");
    value.setValue(suggestion);
    this.suggestion[i] = false;
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/forms/metadata-form/metadata-form.component.ts